import { connect }         from 'react-redux';
import ForgotPassword      from './forgot-password.jsx';
import { requestPassword } from './forgot-password-dux';
import Errors              from '../../../errors';
import SuccessString       from '../../../success';
import {
    dismissError,
    dismissAllErrors }     from '../../../errors-dux';
import { dismissSuccess }  from '../../../success-dux';

export default connect(
    // mapStateToProps
    state => {
      return {
            busy: state.forgotPasswordData.busy,
            success: state.successData.done || false,
            errors: Errors.getByType( state, Errors.ERROR_FORGOTPASSWORD_REQUESTPASSWORD ),
            successMessage: SuccessString.getByType( state, SuccessString.SUCCESS_FORGOTPASSWORD_REQUESTPASSWORD )
        };
    },
    // mapDispatchToProps
    {
        requestPassword,
        dismissError,
        dismissAllErrors,
        dismissSuccess
    }
)( ForgotPassword );
